var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goPrePage",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"返回上一页","placement":"left"}},[_c('i',{staticClass:"iconfont icon-fanhui",staticStyle:{"color":"#444"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }